import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { serverUrl } from "../nestserver";

/* -------------------------------------------------------------------------- */
/*                              Set School Location                           */
/* -------------------------------------------------------------------------- */

export function useSetSchoolLocation(mutationOptions) {
  function setSchoolLocation(data) {
    return axios.put(`${serverUrl}/school-location`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
    });
  }

  return useMutation(setSchoolLocation, mutationOptions);
}

/* -------------------------------------------------------------------------- */
/*                              Get School Location                           */
/* -------------------------------------------------------------------------- */

export function useGetSchoolLocation(queryOptions) {
  async function getSchoolLocation() {
    const res = await axios.get(`${serverUrl}/school-location`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        "Access-Control-Allow-Origin": "*",
      },
    });
    return res.data;
  }

  return useQuery("schoolLocation", getSchoolLocation, queryOptions);
}

/* -------------------------------------------------------------------------- */
/*                              Instructor Check-In                           */
/* -------------------------------------------------------------------------- */

export function useCheckIn(mutationOptions) {
  function checkIn(data) {
    return axios.post(`${serverUrl}/instructor-attendance/check-in`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
    });
  }

  return useMutation(checkIn, mutationOptions);
}

/* -------------------------------------------------------------------------- */
/*                              Instructor Check-Out                          */
/* -------------------------------------------------------------------------- */

export function useCheckOut(mutationOptions) {
  function checkOut(data) {
    return axios.post(`${serverUrl}/instructor-attendance/check-out`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
    });
  }

  return useMutation(checkOut, mutationOptions);
}

/* -------------------------------------------------------------------------- */
/*                         Update Attendance (Admin Only)                     */
/* -------------------------------------------------------------------------- */

export function useUpdateAttendance(mutationOptions) {
  function updateAttendance(attendanceId, data) {
    return axios.put(
      `${serverUrl}/instructor-attendance/${attendanceId}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      },
    );
  }

  return useMutation(
    ({ attendanceId, data }) => updateAttendance(attendanceId, data),
    mutationOptions,
  );
}

/* -------------------------------------------------------------------------- */
/*                              Get Instructor Attendance                     */
/* -------------------------------------------------------------------------- */

export function useGetInstructorAttendance(queryOptions = {}, params = {}) {
  async function getInstructorAttendance(params) {
    const config = {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        "Access-Control-Allow-Origin": "*",
      },
      params: params,
    };

    const res = await axios.get(`${serverUrl}/instructor-attendance`, config);
    return res.data;
  }

  return useQuery(
    ["instructorAttendance", params],
    () => getInstructorAttendance(params),
    queryOptions,
  );
}

/* -------------------------------------------------------------------------- */
/*                       Get Instructor Attendance by Date                    */
/* -------------------------------------------------------------------------- */

export function useGetInstructorAttendanceByDate(
  date,
  queryOptions = {},
  group,
) {
  async function getInstructorAttendanceByDate() {
    if (!date) return [];

    const config = {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        "Access-Control-Allow-Origin": "*",
      },
      params: {
        startDate: date,
        endDate: date,
        // Omitted means instructors, which is what the server assumes.
        ...(group ? { group } : {}),
      },
    };

    const res = await axios.get(`${serverUrl}/instructor-attendance`, config);
    return res.data;
  }

  return useQuery(
    ["instructorAttendanceByDate", date, group],
    getInstructorAttendanceByDate,
    {
      enabled: !!date,
      ...queryOptions,
    },
  );
}
